import React from "react";
import "./Contact.css";
// import { PageWrapper } from "./pages/FormPage"
import ContactForm from "./pages/ContactForm";

const Contact = () => {
  return (
    <section id="contact">
      <h2>Contact me</h2>
      <ContactForm />
    </section>
  );
};

export default Contact;
